import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Email {
    email: string;
}

const initialState: Email = {
    email: '', // начальное состояние
};

const emailStateSlice = createSlice({
    name: 'projectMenuState',
    initialState,
    reducers: {
        setEmail: (state, action: PayloadAction<string>) => {
            state.email = action.payload; // обновляем email в состоянии
        },
    }
});

export const { setEmail } = emailStateSlice.actions;
export default emailStateSlice.reducer;
